import { useState } from 'react'

import {
  dismissDevBadge,
  isDevBadgeDismissed,
  isDevEnvironment
} from '@/shared/lib/runtime/dev-environment'

export function DevEnvironmentBadge() {
  const [visible, setVisible] = useState(
    () => isDevEnvironment && !isDevBadgeDismissed()
  )

  if (!visible) return null

  return (
    <div
      aria-hidden
      className="pointer-events-auto fixed top-[max(0.5rem,env(safe-area-inset-top))] right-[max(0.5rem,env(safe-area-inset-right))] z-[1061] select-none rounded bg-red-600 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-white opacity-80 shadow-sm"
      onDoubleClick={() => {
        dismissDevBadge()
        setVisible(false)
      }}
      title="Duplo clique para ocultar"
    >
      DEV
    </div>
  )
}
